import { render, staticRenderFns } from "./contractStructureMaintenance.vue?vue&type=template&id=508f5dca&scoped=true"
import script from "./contractStructureMaintenance.vue?vue&type=script&lang=js"
export * from "./contractStructureMaintenance.vue?vue&type=script&lang=js"
import style0 from "./contractStructureMaintenance.vue?vue&type=style&index=0&id=508f5dca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f5dca",
  null
  
)

export default component.exports